import React, { forwardRef } from "react";

import { ITypographyProps, Typography } from "../Typography";

export interface ITitleProps {
  /** Font weight. */
  weight?: "light" | "bold";
}

export const Title1 = forwardRef<
  HTMLDivElement,
  ITitleProps & Omit<ITypographyProps, keyof ITitleProps | "variant">
>(({ weight = "light", children, ...props }, ref) => {
  return (
    <Typography weight={weight} variant="Title 1" ref={ref} {...props}>
      {children}
    </Typography>
  );
});

Title1.displayName = "Title1";
